var sliderInfFeatPriMed = tns({
	"container": ".slider-testimonials",
	"controlsContainer": ".slider-testimonials-controls",
	"preventScrollOnTouch": "force",
		"controlsPosition": "bottom",
		"controls": false,
		"navPosition": "bottom",
		"mouseDrag": true,
		"speed": 400,
		"fixedWidth": 288,
		"gutter": 32,
		"responsive": {
			"576": {
				"center": true
			},
			"768": {
				"items": 2,
				"slideBy": 2,
				"center": false
			},
			"1280": {
				"items": 3,
				"slideBy": 3,
				"controls": true,
				"fixedWidth": 316
			}
		}
	});